(function(){
    class ShowContentFromButtonClick {
    
        constructor() {
            var links = document.querySelectorAll('.show-content');
            for (var i = 0; i < links.length; i++)
            {
                const hiddenContentContainer = links[i].closest('.parent-content-container').querySelector('.hidden_content');
                hiddenContentContainer.style.display = 'none';
    
                links[i].addEventListener('click', (ev) => {
                    const parentContainer = ev.target.closest('.parent-content-container');
                    const hiddenContentContainer = parentContainer.querySelector('.hidden_content');
                    const to_be_hidden_post_click = parentContainer.querySelectorAll('.hide-post-click');
                    hiddenContentContainer.style.display = 'block';
                    for (var i = 0; i < to_be_hidden_post_click.length; i++) {
                        to_be_hidden_post_click[i].style.display = 'none';
                    }
                    ev.preventDefault();
                });
    
            }
        }
    }
    
    new ShowContentFromButtonClick();

})()


